import { render, staticRenderFns } from "./OtherAssetsFSSurvey.vue?vue&type=template&id=8efbbe38"
import script from "./OtherAssetsFSSurvey.vue?vue&type=script&lang=ts"
export * from "./OtherAssetsFSSurvey.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports